import { useEffect, useState } from "react";
import messageSentImage from "assets/icons/handshake.svg";
import { UseAppDialogResult } from "components/v2/organisms/app-dialog/AppDialog.hook";
import AppDialog, { AppDialogProps } from "components/v2/organisms/app-dialog/AppDialog";
import AppNotification, { AppNotificationProps } from "components/v2/organisms/app-notification/AppNotification";

export interface MagicLinkDialogProps {
    dialog: UseAppDialogResult;
    requestMagicLink: () => Promise<boolean>;
}

function MagicLinkDialog(props: MagicLinkDialogProps) {
    const { dialog } = props;

    const [loading, setLoading] = useState(true);

    const methods = {
        async requestMagicLink() {
            setLoading(true);

            const requested = await props.requestMagicLink();

            if (requested) {
                setLoading(false);
            }
        },
    };

    const appDialogProps: AppDialogProps = {
        ...dialog.appDialogProps,
        preventClose: loading,
    };

    const loadingNotificationProps: AppNotificationProps = {
        status: "loading",
        heading: "Requesting magic link",
    };

    const notificationProps: AppNotificationProps = {
        status: "success",
        imageAlt: "Email",
        customImage: messageSentImage,
        heading: "We're here to help",
        subHeading: (
            <>
                You seem to be having trouble logging in.
                <br />
                Please check your email for a one-time link. It&apos;s valid for 30 minutes.
            </>
        ),
        primaryButtonProps: {
            children: "Resend email",
            onClick: methods.requestMagicLink,
        },
    };

    useEffect(() => {
        if (props.dialog.isOpen) {
            methods.requestMagicLink();
        }
    }, [props.dialog.isOpen]);

    return (
        <AppDialog {...appDialogProps}>
            <AppNotification {...(loading ? loadingNotificationProps : notificationProps)} />
        </AppDialog>
    );
}

export default MagicLinkDialog;
